import { Button } from '@/shared/ui/Button'
import { useWallet } from '@lair-finance/wallet'
import { useResponsive } from '@/features/responsive/hooks/useResponsive.ts'
import { LiffSDK } from '@/modules/game/shared/lib/sdk/liff.ts'
import { useDappPortalLogin } from '@/modules/game/features/dapp-portal-auth/hooks/useDappPortalLogin.ts'

export function ConnectButton() {
  const isTablet = useResponsive('tablet')
  const { ensureWalletReady } = useWallet()
  const dappPortalLogin = useDappPortalLogin()

  async function handleClick() {
    if (LiffSDK.isInClient()) {
      await dappPortalLogin()
    } else {
      ensureWalletReady()
    }
  }

  return (
    <Button size={isTablet ? 'lg' : 'sm'} onClick={handleClick}>
      Connect Wallet
    </Button>
  )
}
